(function() {
    'use strict';
    angular
        .module('elogbooksControllers')
        .controller('DashboardController', DashboardController);

    DashboardController.$inject = ['user', 'userPreferences', 'dashboardService', 'modulesService'];

    function DashboardController(user, userPreferences, dashboard, modulesService) {
        var vm = this;

        vm.user = user;
        vm.dashboard = dashboard;
        vm.tasksModuleEnabled = modulesService.isEnabled('tasks_module');
        vm.dashboard.reset();
        vm.dashboard.applyUserPreferences(userPreferences);
        dashboard.showStatistics = true;
        dashboard.getStatistics();
    }
})();
